import { Dictionary } from '../../../core';
import { addDictionaryParams, addArrayParams } from '../helpers';
import type { BasePaginatedModel } from './BasePaginatedModel';
import type { ReviewStatus } from './ReviewStatus';

export interface GetReviewsModel extends BasePaginatedModel {
  eventId: string;
  searchTerm?: string;
  userId?: string;
  formEntryId?: string;
  submissionFormEntryId?: string;
  status?: ReviewStatus | '' | null;
  subsetIds?: string[];
  excludedIds?: string[];
  sortDirection?: 'ascending' | 'descending';
  sortField?: string;
  lastUpdateDateFrom?: string;
  lastUpdateDateTo?: string;
  filterChoices?: Dictionary<string[]>;
}

export function toReviewsSearchParams(model: GetReviewsModel): URLSearchParams {
  const query = new URLSearchParams(model as any);
  // URLSearchParams do not handles array, ex: foo=bar1&foo=bar2
  addArrayParams(query, 'subsetIds', model.subsetIds);
  addArrayParams(query, 'excludedIds', model.excludedIds);
  addDictionaryParams(query, 'filterChoices', model.filterChoices);
  query.delete('eventId');
  return query;
}
